import {
  AccountCircle as AccountManagerIcon,
  Tv as DeliveryUnitsIcon,
  Apps as UnitsIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import { Grid, styled } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { UserRoundIcon, WsColors, WsPageHeader, WsUsersRound } from 'wisestep-base';

import { IOption } from '../../../components/SettingsIndex';
import { SideNavBarContainer } from '../../../features/automatedEmailCampaignSettings';
import { lazyImport } from '../../../utils/lazyImport';

const { TeamsAndUsersChildRoutes } = lazyImport(
  () => import('../routes'),
  'TeamsAndUsersChildRoutes'
);

const StyleGrid = styled(Grid)(({ theme }) => ({
  padding: 0,
  position: 'fixed',
  backgroundColor: WsColors.White,
  borderRadius: theme.spacing(0.5),
  width: 280,
  height: 645,
  boxShadow: `${theme.spacing(0)} ${theme.spacing(0.125)} ${theme.spacing(
    0.375
  )} rgba(0, 0, 0, 0.12)`,
}));

const sideMenuOptions: IOption[] = [
  {
    label: 'Teams',
    value: 'teams',
    icon: <WsUsersRound />,
    url: '/workspace-users-and-teams',
  },
  {
    label: 'Users',
    value: 'users',
    icon: <UserRoundIcon />,
    url: '/workspace-users-and-teams/users-list',
  },
  {
    label: 'Account Managers',
    value: 'account-managers',
    icon: <AccountManagerIcon />,
    url: '/workspace-users-and-teams/account-managers',
  },
  {
    label: 'Delivery Units',
    value: 'delivery-units',
    url: '/workspace-users-and-teams/organizational-unit-recruitment',
    icon: <DeliveryUnitsIcon />,
  },
  {
    label: 'Account Manager Units',
    value: 'account-manager-units',
    url: '/workspace-users-and-teams/account-manager-units',
    icon: <UnitsIcon />,
  },
  {
    label: 'Client Units',
    value: 'client-units',
    url: '/workspace-users-and-teams/client-units',
    icon: <UnitsIcon />,
  },
  {
    label: 'Client Contacts Units',
    value: 'client-contact-units',
    url: '/workspace-users-and-teams/client-contacts-units',
    icon: <UnitsIcon />,
  },
  {
    label: 'Business Units',
    value: 'business-units',
    url: '/workspace-users-and-teams/bussiness-units',
    icon: <UnitsIcon />,
  },
  {
    label: 'Jobs & Skills Matrix',
    value: 'jobs-skills-matrix',
    url: '/workspace-users-and-teams/jobs-skills-matrix',
    icon: <DashboardIcon />,
  },
  {
    label: 'Your Dashboards',
    value: 'your-dashboards',
    url: '/workspace-users-and-teams/your-dashboards',
    icon: <DashboardIcon />,
  },
  {
    label: 'Master Dashboards',
    value: 'master-dashboars',
    url: '/workspace-users-and-teams/master-dashboards',
    icon: <DashboardIcon />,
  },
];

const TeamsAndUsers = () => {
  const location = useLocation();

  const getPathnameLabel = () => {
    switch (location.pathname) {
      case '/workspace-users-and-teams':
        return 'Teams';
      case '/workspace-users-and-teams/users-list':
        return 'Recruitment';
      case '/workspace-users-and-teams/bussiness-units':
        return 'Business Units';
      case '/workspace-users-and-teams/organizational-unit-recruitment':
        return 'Organization Units Recruitment';
      case '/workspace-users-and-teams/account-managers':
        return 'Account Managers';
      case '/workspace-users-and-teams/account-manager-units':
        return 'Account Manager Units';
      case '/workspace-users-and-teams/your-dashboards':
        return 'Your Dashboards';
      case '/workspace-users-and-teams/master-dashboards':
        return 'Master Dashboards';
      case '/workspace-users-and-teams/your-dashboards/view':
        return 'view dashboard';
      case '/workspace-users-and-teams/master-dashboards/view':
        return 'view dashboard collection';
      case '/workspace-users-and-teams/jobs-skills-matrix/job-demand-matrix':
        return 'view Job Demand Matrix';
      case '/workspace-users-and-teams/jobs-skills-matrix/talent-matrix':
        return 'view Talent Matrix';
      default:
        return '';
    }
  };

  const viewFlagCheck: boolean =
    getPathnameLabel() && getPathnameLabel().includes('view') ? true : false;

  const currentZoom = window.devicePixelRatio;
  const xsSize = 2.4 * currentZoom;

  return (
    <>
      <Grid item sx={{ mb: 2 }} xs={12}>
        <WsPageHeader title="Dashboard" />
      </Grid>
      <Grid container justifyContent={'space-between'}>
        {viewFlagCheck ? (
          <></>
        ) : (
          <StyleGrid item xs={xsSize}>
            <SideNavBarContainer sideMenuOptions={sideMenuOptions} />
          </StyleGrid>
        )}
        <Grid item xs={viewFlagCheck ? 12 : 10} sx={{ ml: viewFlagCheck ? 0 : 37 }}>
          <TeamsAndUsersChildRoutes />
        </Grid>
      </Grid>
    </>
  );
};

export default TeamsAndUsers;
